let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("llNzy")).then(() => parcelRequire('9YxKt'));